import { useEffect } from 'react';
import { useYamlPreviewData } from './YamlPreview/useYamlPreviewData';
import { ComponentInfoData } from './ComponentInfo/types';
import { SechubData } from './SechubIntegration/types';
import { BlackduckData } from './BlackduckIntegration/types';
import { SonarQubeData } from './SonarQubeIntegration/types';
import { PagerDutyData } from './PagerDutyIntegration/types';

interface YamlDataProviderProps {
  repositoryValue: string;
  infrastructureDependencies: string[];
  providesApis: string[];
  componentInfoData: ComponentInfoData | null;
  sechubData: SechubData | null;
  blackduckData: BlackduckData | null;
  sonarqubeData: SonarQubeData | null;
  pagerdutyData: PagerDutyData | null;
  onYamlChange: (yamlString: string) => void;
  children: React.ReactNode;
}

/**
 * This component wraps the YAML generation logic inside the RepositoryOnboardingProvider context
 * and provides the generated YAML string back to the parent component.
 */
export const YamlDataProvider = ({
  repositoryValue,
  infrastructureDependencies,
  providesApis,
  componentInfoData,
  sechubData,
  blackduckData,
  sonarqubeData,
  pagerdutyData,
  onYamlChange,
  children,
}: YamlDataProviderProps) => {
  // Generate YAML preview data using the shared data and context
  const { yamlString } = useYamlPreviewData({
    repositoryValue,
    infrastructureDependencies,
    providesApis,
    sharedComponentData: componentInfoData,
    sharedSechubData: sechubData,
    sharedBlackduckData: blackduckData,
    sharedSonarqubeData: sonarqubeData,
    sharedPagerdutyData: pagerdutyData,
  });

  // Notify parent component when YAML changes
  useEffect(() => {
    onYamlChange(yamlString);
  }, [yamlString, onYamlChange]);

  return <>{children}</>;
};
